import React from "react";
import { ChevronLeft, ChevronRight, Send } from "lucide-react";

export default function MockNavigation({
  onNext,
  onPrevious,
  disableNext,
  disablePrevious,
  currentPage, // Receive currentPage as a prop
  totalPages, // Receive totalPages as a prop
  handleSubmit, // Receive handleSubmit as a prop
  isSubmitting = false,
}) {
  return (
    <div className="sticky bottom-0 z-20 mt-8 border-t border-slate-200 bg-white/95 px-4 py-4 shadow-[0_-8px_24px_rgba(15,23,42,0.06)] backdrop-blur md:px-8">
      <div className="flex w-full items-center justify-between gap-3">
        <button
          type="button"
          onClick={onPrevious}
          disabled={disablePrevious}
          className={`inline-flex min-h-11 items-center gap-2 rounded-md border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 shadow-sm transition hover:bg-slate-50 ${disablePrevious ? 'cursor-not-allowed opacity-50' : ''}`}
        >
          <ChevronLeft className="h-4 w-4" aria-hidden="true" />
          Previous
        </button>

        <div className="hidden rounded-md bg-slate-50 px-3 py-2 text-center text-xs font-bold uppercase text-gray-500 ring-1 ring-slate-100 sm:block">
          Screen {currentPage} of {totalPages}
        </div>

        {currentPage === totalPages ? (
          <button
            type="button"
            onClick={handleSubmit}
            disabled={isSubmitting}
            className={`inline-flex min-h-11 items-center gap-2 rounded-md bg-violet-600 px-5 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 ${isSubmitting ? 'cursor-wait opacity-75' : ''}`}
          >
            <Send className="h-4 w-4" aria-hidden="true" />
            {isSubmitting ? "Submitting" : "Submit"}
          </button>
        ) : (
          <button
            type="button"
            onClick={onNext}
            disabled={disableNext}
            className={`inline-flex min-h-11 items-center gap-2 rounded-md bg-violet-600 px-5 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 ${disableNext ? 'cursor-not-allowed opacity-50' : ''}`}
          >
            Next
            <ChevronRight className="h-4 w-4" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
}
